var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table-header" }, [
    _c("span", {
      staticClass: "table-header__column",
      attrs: { "data-column": "title" },
      domProps: { textContent: _vm._s("Title") },
    }),
    _vm._v(" "),
    _c("span", {
      staticClass: "table-header__column",
      attrs: { "data-column": "category" },
      domProps: { textContent: _vm._s("Category") },
    }),
    _vm._v(" "),
    _c("span", {
      staticClass: "table-header__column",
      attrs: { "data-column": "sector" },
      domProps: { textContent: _vm._s("Main Sector") },
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "table-header__column",
        attrs: { "data-column": "created" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.changeSort.apply(null, arguments)
          },
        },
      },
      [
        _c("span", { domProps: { textContent: _vm._s("Created") } }),
        _vm._v(" "),
        _vm.sort && (_vm.sort === "asc" || _vm.sort === "desc")
          ? _c(
              "svg",
              {
                class: {
                  "svg-icon": true,
                  "sort-icon": true,
                  sort: true,
                  "sort--asc": this.sort && this.sort === "asc",
                  "sort--desc": this.sort && this.sort === "desc",
                },
              },
              [_c("use", { attrs: { "xlink:href": "#icon--sort" } })]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }